var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (JSON, fieldsetCounter, globals, id, sliderOptions, validationId) {
      pug_mixins["intro"] = pug_interp = function(data){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!data) { data={is_bonus: false}; }
if (data.process === 'NEO') {
pug_html = pug_html + "\u003Cdiv class=\"wizardbox centered\" ng-class=\"{highlighted: &quot;intro&quot; == component.box.step}\"\u003E\u003Cdiv class=\"header\" ng-class=\"{show: &quot;intro&quot; == component.box.step }\"\u003E\u003Ca ng-click=\"component.toggleStep(&quot;intro&quot;)\"\u003E\u003Cspan class=\"step\"\u003E1\u003C\u002Fspan\u003E\u003Cspan class=\"title\"\u003E" + (pug.escape(null == (pug_interp = data.title || 'So funktioniert´s') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\" ng-if=\"&quot;intro&quot; == component.box.step\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"step1\"\u003E";
if (data.video) {
pug_html = pug_html + "\u003Cdiv class=\"video-wrap\"\u003E\u003Ciframe" + (pug.attr("src", data.video, true, true)+pug.attr("webkitallowfullscreen", true, true, true)+pug.attr("mozallowfullscreen", true, true, true)+pug.attr("allowfullscreen", true, true, true)) + "\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cspan class=\"subtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subtitle) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"subsubtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subsubtitle) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"description\"\u003E" + (pug.escape(null == (pug_interp = data.description) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cbr\u003E\u003Cp class=\"error\" ng-show=\"component.is_already_used\"\u003ESie nutzen bereits diesen Baustein!\u003C\u002Fp\u003E\u003Ca class=\"button button-primary float-right\" ng-click=\"component.toggleStep(&quot;values&quot;)\" ng-if=\"!component.is_pc\" data-cy=\"neo.preCheckout.basicComponent.wizardBegin.buttonNext\"\u003EWeiter\u003C\u002Fa\u003E\u003Ca class=\"button button-primary right\" ng-click=\"component.goToMPP()\" ng-if=\"component.is_pc\" data-cy=\"neo.preCheckout.pcLeasing.wizardBegin.buttonNext\"\u003EWeiter\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
if (data.process === 'BONUS') {
pug_html = pug_html + "\u003Cdiv class=\"wizardbox centered\"\u003E\u003Cdiv class=\"header\"\u003E\u003Ca\u003E\u003Cspan class=\"step\"\u003E1\u003C\u002Fspan\u003E\u003Cspan class=\"title\"\u003E" + (pug.escape(null == (pug_interp = data.title || 'So funktioniert´s') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"step1\"\u003E";
if (data.video) {
pug_html = pug_html + "\u003Cdiv class=\"video-wrap\"\u003E\u003Ciframe" + (pug.attr("src", data.video, true, true)+pug.attr("webkitallowfullscreen", true, true, true)+pug.attr("mozallowfullscreen", true, true, true)+pug.attr("allowfullscreen", true, true, true)) + "\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E";
}
if (data.image) {
pug_html = pug_html + "\u003Cdiv class=\"baustein\"\u003E\u003Cdiv class=\"bausteinContainer\"\u003E\u003Ca" + (" class=\"imgWrapper\""+pug.attr("ng-href", '/module/' + data.image, true, true)) + "\u003E\u003Cdiv" + (" class=\"imgContainer\""+pug.attr("style", pug.style('background-image: url(/assets/img/bonus/' + data.image + '.jpg)'), true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cspan class=\"subtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subtitle) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"subsubtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subsubtitle) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"subsubtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subsubtitle2) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cbr\u003E";
block && block();
pug_html = pug_html + "\u003Cbr\u003E\u003Cdiv class=\"row\" ng-if=\"component.isBonusCancelled() || !component.isProjectApproved()\"\u003E\u003Cp class=\"red\"\u003EDer Checkout ist leider nicht möglich.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"!component.hasSachbezugCheckouts &amp;&amp; component.all_active_checkouts.length &gt; 0\"\u003E\u003Cspan class=\"red\"\u003ESie nutzen bereits diese Wahlleistung für den Zeitraum\u003C\u002Fspan\u003E\u003Cspan ng-repeat=\"bonus_checkout in component.all_active_checkouts\"\u003E{{ component.getComponentDisplayStartDate(bonus_checkout) | date }} bis {{ component.getComponentDisplayEndDate(bonus_checkout) | date }} mit einem monatlichen Betrag von {{ bonus_checkout.checkout_config.per_month_value | currency : 'EUR' }}.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cspan class=\"red\" ng-if=\"component.hasSachbezugCheckouts\"\u003ESie nutzen bereits diese Wahlleistung für den Zeitraum\u003C\u002Fspan\u003E\u003Cbr\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"component.allSachbezugCheckouts['sachbezug'] &amp;&amp; component.allSachbezugCheckouts['sachbezug'].length &gt; 0\"\u003E\u003Cspan class=\"red\"\u003ESACHBEZUG | VORTEILSKONTO\u003C\u002Fspan\u003E\u003Cspan ng-repeat=\"bonus_checkout in component.allSachbezugCheckouts['sachbezug']\"\u003E{{ component.getComponentDisplayStartDate(bonus_checkout) | date }} bis {{ component.getComponentDisplayEndDate(bonus_checkout) | date }} mit einem monatlichen Betrag von {{ bonus_checkout.checkout_config.per_month_value | currency : 'EUR' }}.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"component.allSachbezugCheckouts['sachbezug_pluxee'] &amp;&amp; component.allSachbezugCheckouts['sachbezug_pluxee'].length &gt; 0\"\u003E\u003Cspan class=\"red\"\u003ESACHBEZUG | BENEFITS CARD\u003C\u002Fspan\u003E\u003Cspan ng-repeat=\"bonus_checkout in component.allSachbezugCheckouts['sachbezug_pluxee']\"\u003E{{ component.getComponentDisplayStartDate(bonus_checkout) | date }} bis {{ component.getComponentDisplayEndDate(bonus_checkout) | date }} mit einem monatlichen Betrag von {{ bonus_checkout.checkout_config.per_month_value | currency : 'EUR' }}.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"component.allSachbezugCheckouts['sachbezug_profit'] &amp;&amp; component.allSachbezugCheckouts['sachbezug_profit'].length &gt; 0\"\u003E\u003Cspan class=\"red\"\u003ESACHBEZUG | FITNESSKONTO\u003C\u002Fspan\u003E\u003Cspan ng-repeat=\"bonus_checkout in component.allSachbezugCheckouts['sachbezug_profit']\"\u003E{{ component.getComponentDisplayStartDate(bonus_checkout) | date }} bis {{ component.getComponentDisplayEndDate(bonus_checkout) | date }} mit einem monatlichen Betrag von {{ bonus_checkout.checkout_config.per_month_value | currency : 'EUR' }}.\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\" ng-if=\"!component.isBonusDefaultStartDateCheckoutAvailable &amp;&amp; !component.is_component_cashback\"\u003E\u003Cp class=\"red\"\u003EDiese Wahlleistung steht in diesem Projekt aktuell nicht zur Verfügung.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"(component.is_component_cashback &amp;&amp; !component.is_cashback_request_available) || !component.isDecisionDateValid()\"\u003E\u003Cp class=\"red\"\u003EDer Zeitraum zur Beantragung dieser Wahlleistung ist abgelaufen.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row red\" ng-if=\"component.isPcBlocked\"\u003E\u003Cp class=\"red\"\u003EDie Wahlleistung PC Leasing ist leider gesperrt.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row red\" ng-if=\"component.disableCheckoutIfMultipleSachbezugCheckouts\"\u003E\u003Cbr\u003E\u003Cp class=\"red\"\u003ESie beantragen bereits die Wahlleistung - {{ component.sachbezugCheckedoutComponent }}. Bitte schließen Sie zuerst diese Beantragung ab.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cbutton class=\"button button-primary float-left\" ng-click=\"component.navigateBackToDashboard()\" data-cy=\"bonus.preCheckout.basicComponent.wizardBegin.buttonPrevious\"\u003Ezurück zur Übersicht\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary float-right\" ng-click=\"component.addComponentToEmployeeBonusComponents()\" ng-if=\"component.isDecisionDateValid() &amp;&amp; !component.is_component_cashback &amp;&amp; component.canContinue()\" data-cy=\"bonus.preCheckout.basicComponent.wizardBegin.buttonNext\"\u003E" + (pug.escape(null == (pug_interp = data.label_next_button || 'Weiter') ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary float-right\" ng-click=\"component.continueToCashbackRequestStep()\" ng-if=\"component.isDecisionDateValid() &amp;&amp; component.is_component_cashback &amp;&amp; component.is_cashback_request_available\" data-cy=\"bonus.preCheckout.basicComponent.wizardBegin.buttonNext\"\u003E" + (pug.escape(null == (pug_interp = data.label_next_button || 'Weiter') ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
if (data.process === 'NEO_COMPONENT') {
pug_html = pug_html + "\u003Cdiv class=\"wizardbox centered\" overlay=\"!$ctrl.isLoaded\"\u003E\u003Cdiv class=\"header\"\u003E\u003Ca\u003E\u003Cspan class=\"step\"\u003E1\u003C\u002Fspan\u003E\u003Cspan class=\"title\"\u003E" + (pug.escape(null == (pug_interp = data.title || 'So funktioniert´s {{ $ctrl.neo_component.title }}') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"step1\"\u003E";
if (data.video) {
pug_html = pug_html + "\u003Cdiv class=\"video-wrap\"\u003E\u003Ciframe" + (pug.attr("src", data.video, true, true)+pug.attr("webkitallowfullscreen", true, true, true)+pug.attr("mozallowfullscreen", true, true, true)+pug.attr("allowfullscreen", true, true, true)) + "\u003E\u003C\u002Fiframe\u003E\u003C\u002Fdiv\u003E";
}
if (data.image) {
pug_html = pug_html + "\u003Cdiv class=\"baustein\"\u003E\u003Cdiv class=\"bausteinContainer\"\u003E\u003Ca" + (" class=\"imgWrapper\""+pug.attr("ng-href", '/module/' + data.image, true, true)) + "\u003E\u003Cdiv" + (" class=\"imgContainer\""+pug.attr("style", pug.style('background-image: url(/assets/img/bonus/' + data.image + '.jpg)'), true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cspan class=\"subtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subtitle) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"subsubtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subsubtitle) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"subsubtitle\"\u003E" + (pug.escape(null == (pug_interp = data.subsubtitle2) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cbr\u003E";
block && block();
pug_html = pug_html + "\u003Cp class=\"red\" ng-if=\"$ctrl.isBlockedForPcLeasing\"\u003EDie Wahlleistung PC Leasing ist leider gesperrt.\u003C\u002Fp\u003E\u003Cbr\u003E\u003Cbutton class=\"button button-primary float-left\" ng-click=\"$ctrl.navigateBackToDashboard()\" data-cy=\"neo.preCheckout.basicComponent.wizardBegin.buttonPrevious\"\u003Ezurück zur Übersicht\u003C\u002Fbutton\u003E\u003Cspan class=\"right\" ng-if=\"$ctrl.isLoaded\"\u003E\u003Cbutton class=\"button button-primary float-right\" ng-click=\"$ctrl.enterStepTwo()\" ng-if=\"$ctrl.canEnterStepTwo() &amp;&amp; $ctrl.doesUserHasSalary\" data-cy=\"neo.preCheckout.basicComponent.wizardBegin.buttonNext\"\u003E" + (pug.escape(null == (pug_interp = data.label_next_button || 'Weiter') ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E\u003Cdiv class=\"float-right\" ng-if=\"!$ctrl.canEnterStepTwo()\"\u003E\u003Cp class=\"error\"\u003EDer Abruf von PC-Leasing ist akuell nicht möglich.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"float-right\" ng-if=\"!$ctrl.doesUserHasSalary\"\u003E\u003Cp class=\"error\"\u003EEine Beantragung ist aufgrund fehlender Einstellungen aktuell nicht möglich.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
};
pug_mixins["values"] = pug_interp = function(data){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!data) { data={is_bonus: false}; }
if (data.process === 'NEO') {
pug_html = pug_html + "\u003Cdiv class=\"wizardbox centered\" ng-class=\"{highlighted: &quot;values&quot; == component.box.step}\"\u003E\u003Cdiv class=\"header\" ng-class=\"{show: &quot;values&quot; == component.box.step }\"\u003E\u003Ca ng-click=\"component.toggleStep(&quot;values&quot;)\"\u003E\u003Cspan class=\"step\"\u003E2\u003C\u002Fspan\u003E\u003Cspan class=\"title\"\u003E" + (pug.escape(null == (pug_interp = data.title || '') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\" ng-if=\"&quot;values&quot; == component.box.step\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"step2\"\u003E";
block && block();
pug_html = pug_html + "\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E";
if (data.description) {
pug_html = pug_html + "\u003Cspan class=\"description\"\u003E" + (pug.escape(null == (pug_interp = data.description) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003Cbr\u003E\u003Cbr\u003E\u003Ca class=\"button button-primary right\" ng-disabled=\"!component.canExitValuesScreen()\" ng-click=\"component.toggleStep(&quot;checkout&quot;)\" data-cy=\"neo.preCheckout.basicComponent.wizardConfig.buttonNext\"\u003EWeiter\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
if (data.process === 'BONUS') {
pug_html = pug_html + "\u003Cdiv class=\"wizardbox centered\"\u003E\u003Cdiv class=\"header\"\u003E\u003Ca\u003E\u003Cspan class=\"step\"\u003E2\u003C\u002Fspan\u003E\u003Cspan class=\"title\"\u003E" + (pug.escape(null == (pug_interp = data.title || '') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"step2 flex-column\"\u003E";
block && block();
pug_html = pug_html + "\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E";
if (data.description) {
pug_html = pug_html + "\u003Cspan class=\"description\"\u003E" + (pug.escape(null == (pug_interp = data.description) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003Cbr\u003E\u003Cbr\u003E\u003Cdiv\u003E\u003Cbutton class=\"button button-primary left\" wz-cancel data-cy=\"bonus.preCheckout.basicComponent.wizardConfig.buttonCancel\"\u003Ezurück zur Übersicht\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary right\" wz-next ng-disabled=\"!component.toAllowComponentAddition()\" ng-if=\"component.step2SelectionPossible()\" ng-click=\"component.stepValuesHandler &amp;&amp; component.stepValuesHandler()\" data-cy=\"bonus.preCheckout.basicComponent.wizardConfig.buttonConfirm\"\u003E" + (pug.escape(null == (pug_interp = data.step2ButtonTitle || 'Auswahl übernehmen') ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
if (data.process === 'NEO_COMPONENT') {
pug_html = pug_html + "\u003Cdiv class=\"wizardbox centered\"\u003E\u003Cdiv class=\"header\"\u003E\u003Ca\u003E\u003Cspan class=\"step\"\u003E2\u003C\u002Fspan\u003E\u003Cspan class=\"title\"\u003E" + (pug.escape(null == (pug_interp = data.title || '') ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Cdiv class=\"step2 flex-column\"\u003E";
block && block();
pug_html = pug_html + "\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E";
if (data.description) {
pug_html = pug_html + "\u003Cspan class=\"description\"\u003E" + (pug.escape(null == (pug_interp = data.description) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003Cbr\u003E\u003Cbr\u003E\u003Cdiv\u003E\u003Cbutton class=\"button button-primary left\" wz-cancel\u003Ezurück zur Übersicht\u003C\u002Fbutton\u003E\u003Cbutton class=\"button button-primary right\" wz-next ng-disabled=\"!$ctrl.toAllowComponentAddition()\" ng-if=\"$ctrl.step2SelectionPossible()\" data-cy=\"neo.preCheckout.basicComponent.wizardConfig.buttonNext\"\u003EAuswahl übernehmen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
};
pug_mixins["slider"] = pug_interp = function(data, cyData){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!data) { data={}; }
if (undefined === data.htmlClass) { data.htmlClass = 'currency'; }
if (undefined === data.value) { data.value = '0'; }
if (false === data.value) { delete data.value; }
if (!data.from ) { data.from = 0; }
if (undefined === data.if) { data.if = 'false'; }

// sliderOptions.steps? to define where the steps are ended?
// Formula to calculate split?

sliderOptions = '';

if (undefined !== data.from) { sliderOptions += 'component.sliderOptions.from = ' + JSON.stringify(data.from) +';'; }
if (undefined !== data.to) { sliderOptions += 'component.sliderOptions.to = component.sliderOptions.to || ' + JSON.stringify(data.to) +';'; }
if (undefined !== data.value) { sliderOptions += 'component.sliderOptions.value = ' + JSON.stringify(data.value) +';'; }

pug_html = pug_html + "\u003Cspan" + (" style=\"display:none\""+pug.attr("ng-init", sliderOptions, true, true)) + "\u003E\u003C\u002Fspan\u003E\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes([data.htmlClass], [true]),"id": "mySlider1","ng-if": "component.model","ng-model": pug.escape(data.model || 'component.model.value'),"type": "number","slider": pug.escape(true),"options": pug.escape(data.sliderOptions || data.options || 'component.sliderOptions'),"data-cy": pug.escape(cyData)},attributes]), true)) + "\u003E";
};


















pug_mixins["input"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.type) {
attributes.type = 'text'
}
if (!attributes.attributes) {
attributes.attributes = {}
}
if (!attributes.groupAttributes) {
attributes.groupAttributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["form-group",attributes.groupHtmlClass], [false,false])},attributes.groupAttributes]), true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes(["control-label",attributes.labelHtmlClass], [false,true]), false, true)+pug.attr("for", id, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E";
}
if (attributes.divTitle) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["control-label",attributes.divTitleHtmlClass], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = attributes.divTitle) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"id": pug.escape(id),"type": pug.escape(attributes.type),"placeholder": pug.escape(attributes.placeholder),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"name": pug.escape(id),"value": pug.escape(attributes.value),"required": pug.escape(attributes.required),"ng-pattern": pug.escape(attributes['ng-pattern']),"disabled": pug.escape(attributes.disabled),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};



















































































































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};





























































pug_mixins["form"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.name) {
globals.formname = attributes.name
}
pug_html = pug_html + "\u003Cform" + (pug.attrs(pug.merge([{"novalidate": pug.escape(true)},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fform\u003E";
};
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_html = pug_html + "\u003Cdiv ng-if=\"(component.loading.parent || component.loading.child)\"\u003ELoading\u003C\u002Fdiv\u003E\u003Cwizard hide-indicators=\"true\" ng-if=\"!(component.loading.parent || component.loading.child)\" on-finish=\"component.wizardFinished()\" on-cancel=\"component.wizardCanceled()\"\u003E\u003Cwz-step wz-title=\"Intro\" edit-mode=\"true\"\u003E";
pug_mixins["intro"].call({
block: function(){
pug_html = pug_html + "\u003Cp ng-if=\"component.iAmFiduciaUser\"\u003E\u003Cstrong\u003EQ&A:\u003C\u002Fstrong\u003E Die wichtigsten Fragen und Antworten finden Sie unter\u003Ca href=\"https:\u002F\u002Fweconnect.in.fiduciagad.de\u002Fcommunities\u002Fservice\u002Fhtml\u002Fcommunityview?communityUuid=c07b5c3c-d081-4b26-bbbe-b32acea3e412#fullpageWidgetId=W039a60bfc22b_4cbd_b6c2_2c4dc05e22c8&amp;file=5ae98b44-32f2-49fd-b989-c7426ece62b0\" target=\"_blank\"\u003Ediesem Link\u003C\u002Fa\u003E(intern).\u003C\u002Fp\u003E\u003Cp\u003EGrundsätzlich ist die Bezuschussung von Mobilfunkverträgen möglich, die kein subventioniertes Endgerät enthalten und die Rechnung auf Ihren Namen läuft. Das heißt, in der monatlichen Grundgebühr darf keine Endgerätefinanzierung enthalten sein. Prepaid ist generell ausgeschlossen.\u003C\u002Fp\u003E\u003Cp class=\"red\"\u003EDiese Positionen dürfen \u003Cstrong\u003Enicht\u003C\u002Fstrong\u003E angesetzt werden:\u003C\u002Fp\u003E\u003Cul\u003E\u003Cli\u003E\u003Cspan class=\"left\"\u003EMonatlicher Grundpreis inkl. Ratenzahlung für ein Mobiltelefon\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan class=\"left\"\u003EKosten für die Bereitstellung von Einzelverbindungen \u002F Einzelnachweise\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan class=\"left\"\u003EGuthaben & Aktionsrabatte\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan class=\"left\"\u003EExtra Datenvolumen\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cp\u003EAchten Sie bitte daher auf die Angabe der Werte, um eine schnelle Freigabe zu erhalten.\u003C\u002Fp\u003E\u003Cp\u003EFür die Bereitstellung des Gerätes wird eine Gerätemiete von {{ component.get_additional_tax_value(undefined, component.TAX_TYPE_BY_NAME['yearly']['id'])['overall'] | currency: 'EUR' }} einmalig pro Kalenderjahr fällig. Dies wird Ihrem Budget belastet und erscheint im Rahmen der Beantragung in der Budgetübersicht als separater Posten.\u003C\u002Fp\u003E";
}
}, {
      process: 'BONUS',
      video:       'https://player.vimeo.com/video/397980901?dnt=1',
      subtitle:    'Steuerfrei Telefonieren (Mobil)',
      subsubtitle: 'Wenn Sie einen Vertrag (kein Prepaid) mit einem Mobilfunkanbieter haben, kann Ihr Arbeitgeber Teile Ihrer Rechnung übernehmen. Um diesen Vorteil zu nutzen, muss Ihr Arbeitgeber Eigentümer des Gerätes sein und Ihnen dieses zur Verfügung stellen, hierfür erhalten Sie von uns ein Handy.',
    });
pug_html = pug_html + "\u003C\u002Fwz-step\u003E\u003Cwz-step wz-title=\"Values\" edit-mode=\"true\" wz-data=\"{calculation_promise : component.calculation_promise}\" canenter=\"component.waitForCalculation\"\u003E";
pug_mixins["values"].call({
block: function(){
pug_html = pug_html + "\u003Cdiv ng-if=\"component.model.sliders\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_html = pug_html + "\u003Cp\u003EIhr Arbeitgeber kann die Kosten für Ihren Mobilfunkvertrag übernehmen.\u003C\u002Fp\u003E\u003Cdiv class=\"cent_slider\"\u003E";
pug_mixins["slider"](
              {
                model: 'component.model.advantage',
                options: 'component.model.sliders.advantage'
              },
              'bonus.preCheckout.mobilePhone.wizardConfig.slider'
            );
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cp\u003EBitte geben Sie die monatliche Grundgebühr Ihres Mobilfunkvertrages an. Über den Slider wählen Sie den Eurobetrag aus, im Feld darunter können Sie den Betrag genau angeben.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-6 right\"\u003E";
pug_mixins["input"].call({
attributes: {"key": "component.model.advantage","title": "exakte monatliche Kosten","required": pug.escape(true),"attributes": {"vn-currency":"true","vn-max":"{{component.model.sliders.advantage.to}}","vn-min":"{{component.model.sliders.advantage.from}}"},"validationMessages": {"required":"Bitte Eingabe prüfen","numberOrEmpty":"Bitte Eingabe prüfen","vnMin":"Der minimale Wert beträgt {{ component.model.sliders.advantage.from | currency }}","vnMax":"Der maximale Wert beträgt {{ component.model.sliders.advantage.to | currency }}"}}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C!--pre {{ component.model.months | json }}--\u003E";
pug_mixins["slider"](
            {
              model: 'component.model.months',
              options: 'component.model.sliders.months',
              htmlClass: false
            },
            'bonus.preCheckout.mobilePhone.wizardConfig.slider'
          );
pug_html = pug_html + "\u003Cp\u003EBitte geben Sie die Anzahl der Monate an, in denen Sie die Leistung beanspruchen möchten.\u003C\u002Fp\u003E";
},
attributes: {"name": "component.forms.value_form"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cp ng-if=\"component.model.months &gt; 1\"\u003ESie erhalten von {{component.bonus_start_month_year | date : component.dateFormat }} bis {{ component.bonus_end_month_year | date : component.dateFormat }} einen Betrag von {{component.model.per_month_value | currency:'EUR' }} monatlich.\u003C\u002Fp\u003E\u003Cp ng-if=\"component.model.months === 1\"\u003ESie erhalten im {{component.bonus_start_month_year | date : component.dateFormat }} einen Betrag von {{component.model.per_month_value | currency:'EUR' }} monatlich.\u003C\u002Fp\u003E\u003Cp ng-if=\"component.is_additional_tax_enabled()\"\u003EDie gewählte Leistung hat eine Gerätemiete in Höhe von {{ component.get_additional_tax_value(undefined, component.TAX_TYPE_BY_NAME['yearly']['id'])['overall'] | currency: 'EUR' }}  für die Bereitstellung des erforderlichen Endgerätes im gewählten Zeitraum zur Folge, die zusätzlich vom Budget abgezogen wird.\u003C\u002Fp\u003E";
}
}, {
      process: 'BONUS',
      title:       'Bitte geben Sie die monatliche Grundgebühr Ihres Mobilfunkvertrages ein.',
    });
pug_html = pug_html + "\u003C\u002Fwz-step\u003E\u003C\u002Fwizard\u003E";
    }.call(this, "JSON" in locals_for_with ?
        locals_for_with.JSON :
        typeof JSON !== 'undefined' ? JSON : undefined, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "sliderOptions" in locals_for_with ?
        locals_for_with.sliderOptions :
        typeof sliderOptions !== 'undefined' ? sliderOptions : undefined, "validationId" in locals_for_with ?
        locals_for_with.validationId :
        typeof validationId !== 'undefined' ? validationId : undefined));
    ;;return pug_html;};
module.exports = template;